import {
  Menu,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { FaFileExport } from "react-icons/fa";
import { ReportMenuButton } from "../../Shared/Components/ReportMenuButton";
import { reportToolbarStyles } from "../../Shared/Styles/reportToolbarStyles";

export default function ProfitAndLossActions({ onExport, isExporting, texts }) {
  return (
    <Menu>
      <ReportMenuButton leftIcon={<FaFileExport />}>
        {isExporting
          ? texts.reports?.exporting || "Exporting..."
          : texts.reports?.export || "Export"}
      </ReportMenuButton>
      <MenuList {...reportToolbarStyles.menuList}>
        <MenuItem onClick={() => onExport("PDF")} py={1} fontSize="xs">
          {texts.reports?.toPDF || "To PDF"}
        </MenuItem>
        <MenuItem onClick={() => onExport("Excel")} py={1} fontSize="xs">
          {texts.reports?.toExcel || "To Excel"}
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
